import { render, staticRenderFns } from "./FirebaseRegister.vue?vue&type=template&id=87aa73f6"
import script from "./FirebaseRegister.vue?vue&type=script&lang=js"
export * from "./FirebaseRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports